export default __webpack_public_path__ + "static/media/1_0082.3bd705f1.webp";